import Widget from './WidgetsList'
export default Widget
